export const newPostAction = "jab";
export const newYammerPostAction = "kab";
export default {newPostAction,newYammerPostAction};